const flightsSearchBody = (state = null, action) => {
  switch (action.type) {
    case 'SET_SEARCH_FLIGHTS_BODY':
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default flightsSearchBody;
